import * as SpecialOffersConstants from './constants';
import * as D from './deps';

export function redeemCode({
  specialOfferCode,
  offerType = SpecialOffersConstants.OfferTypes.CODE_PRODUCT,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.GET_SPECIAL_OFFER_V2,
    content: {
      specialOfferType: offerType,
      specialOfferToken: specialOfferCode,
    },
  });
}
